import PropTypes from 'prop-types';
import React from 'react';

const Download = ({ width, height }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 15 18">
    <title>Download Icon</title>
    <g fill="none" fillRule="evenodd">
      <g fill="currentColor" fillRule="nonzero">
        <g>
          <path
            d="M23.488 26.916c.234 0 .469-.084.703-.319l2.64-2.53c.15-.16.243-.319.243-.553 0-.436-.369-.746-.78-.746-.225 0-.435.092-.586.26l-.972 1.03-.477.62.125-1.164v-8.011c0-.478-.394-.889-.896-.889-.503 0-.897.411-.897.889v8.01l.117 1.165-.469-.62-.972-1.03c-.16-.168-.369-.26-.595-.26-.41 0-.77.31-.77.746 0 .234.083.394.234.553l2.64 2.53c.234.235.469.319.712.319zm4.567 5.003c1.801 0 2.782-.973 2.782-2.757v-7.634c0-1.785-.98-2.766-2.782-2.766H26.01v2.003h1.827c.645 0 .997.319.997 1.006v7.148c0 .687-.352 1.005-.997 1.005h-8.749c-.645 0-.989-.318-.989-1.005V21.77c0-.687.344-1.006.99-1.006h1.876v-2.003H18.88c-1.802 0-2.782.98-2.782 2.766v7.634c0 1.784.98 2.757 2.782 2.757h9.176z"
            transform="translate(-1378 -130) translate(1362 116)"
          />
        </g>
      </g>
    </g>
  </svg>
);

Download.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Download.defaultProps = {
  width: 15,
  height: 18,
};

export default Download;
